import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  title: {
    id: 'donater.form.goal.title',
    defaultMessage: 'Goal',
  },
  availableUntil: {
    id: 'donater.form.goal.available',
    defaultMessage: 'Available until',
  },
  without: {
    id: 'donater.form.goal.without_goal',
    defaultMessage: 'Without goal',
  },
})
